import { Container } from "@mui/material";
import React from "react";
import { Box, Button, Grid, Link, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import Sella from "./Sella.png";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { useState, useEffect } from "react";
import Url from "../services/Url";
import { useSharedStore } from "../services/SharedStore";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Intestazione = styled(Box)({
  fontFamily: "Montserrat, sans-serif",
  fontSize: "31px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "normal",
  textAlign: "center",
  color: "#1b1b1b",
});

const CompilaCampi = styled(Box)({
  fontFamily: "Lato",
  fontSize: "15px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.11px",
  textAlign: "center",
  color: "#7b7b7b",
});

const ChoseUser = styled(Box)({
  fontFamily: "Lato",
  fontSize: "18px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.13px",
  textAlign: "center",
  color: "#4d606f",
});

const SelezioneUser = styled(RadioGroup)({
  textAlign: "center",
});

const ElementoLista = styled(FormControlLabel)({
  fontFamily: "Lato",
  fontSize: "15px",
  fontWeight: "bold",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "normal",
  color: "#4d606f",
  textAlign: "center",
});

const SendEmailButton = styled(Button)({
  fontFamily: "Lato",
  fontSize: "16px",
  fontWeight: "bold",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.11px",
  color: "#339aef",
  textTransform: "none",
});

const ListaUsers = styled(FormControl)({
  textAlign: "center",
});

const SimpleBox = styled(Box)({
  textAlign: "center",
});

const UserList = styled(Grid)({
  marginTop: "10px",
});

const SimpleBox2 = styled(Box)({
  textAlign: "center",
  marginTop: "36px"
});

const ResponseSendCodes = styled(Box)({
  fontFamily: 'Lato',
  fontSize: '18px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: '0.13px',
  textAlign: 'center',
  color: '#4d606f'
});

const UpButton = styled(Button)({
  borderRadius: "0px",
  height: "50px",
  boxShadow: "none",
  textTransform: "none",
  fontFamily: "Montserrat, sans-serif",
  fontSize: "12px",
  fontWeight: "600",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#fff",
  backgroundColor: "#339aef",
  "&:hover": {
    backgroundColor: "#339aef",
  },
  "&:active": {
    backgroundColor: "#339aef",
  },
  "&:focus": {
    backgroundColor: "#339aef",
  },
});

const BackButton = styled(Button)({
  borderRadius: "0px",
  height: "50px",
  boxShadow: "none",
  textTransform: "none",
  fontFamily: "Montserrat, sans-serif",
  fontSize: "12px",
  fontWeight: "600",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#fff",
  backgroundColor: "#4d606f",
  "&:hover": {
    backgroundColor: "#4d606f",
  },
  "&:active": {
    backgroundColor: "#4d606f",
  },
  "&:focus": {
    backgroundColor: "#4d606f",
  },
});
const Buttons = styled(Grid)({
  marginTop: "36px",
});

function SelectUserName() {
  const [loading, setloading] = useState(false);
  const { getStore, addStore, getStoreAsync } = useSharedStore();
  const [value, setValue] = useState('');
  const [users, setUsers] = useState([]);
  const [notCode, setNotCode] = useState(false);
  const [sendCodesResponse, setSendCodesResponse] = useState("");
  const [responseCode, setResponseCode] = useState("");
  let history = useNavigate();

  const close = () => {
    history("/");
  }


  const handleChange = (event) => {
    setValue(event.target.value);
    if (event.target.labels[0].textContent.includes("****")) {
      addStore("user", event.target.labels[0].textContent);
      setNotCode(false);
    } else {
      setNotCode(true);
    }
  };

  const getEmails = () => {
    setloading(true);
    getStoreAsync("token").then(val => {
      axios.get(Url + "api/getcodeb", {
        headers: {
          'Authorization': val
        }
      }).then(res => {
        setloading(false);
        if (res.data.response_code == "CR_4_30") {
          setUsers(res.data.response_data);
          setValue(res.data.response_data[0].id);
          if (res.data.response_data[0].code.includes("****")) {
            setNotCode(false);
          } else {
            setNotCode(true);
          }
        }
      })
    })
  }

  useEffect(() => {
    setloading(false);
    window.scrollTo(0, 0);
    getEmails();
  }, []);

  const getSetEmail = () => {
    setloading(true);
    axios.get(Url + "api/setcodeb/" + value, {
      headers: {
        'Authorization': getStore("token")
      }
    }).then(res => {
      setloading(false);
      if (res.data.response_code == "CR_5_30" && notCode == true) {
        addStore("token", res.data.response_data);
        history("/OTP");
      } else if (res.data.response_code == "CR_5_30" && notCode == false) {
        addStore("token", res.data.response_data);
        history("/insertpassword");
      }
    })
  };

  const sendCodes = () => {
    setloading(true);
    axios.get(Url + "api/sendcodeb/" + value, {
      headers: {
        'Authorization': getStore("token")
      }
    }).then(res => {
      setloading(false);
      setResponseCode(res.data.response_code);
      setSendCodesResponse(res.data.response_desc);
    })
  }

  const date = new Date();
  const currentYear = date.getFullYear();

  return (
    <Container maxWidth="xl">
      <Grid container>
        <Grid class="logoContainer" item xs={12} sm={12} md={12}>
          <img class="logo" src={Sella}></img>
        </Grid>
      </Grid>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <Intestazione>Recupera il tuo Codice Cliente o Username</Intestazione>
        </Grid>
      </Grid>
      <br></br>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <CompilaCampi>
            Compila i campi per recuperare il Codice Cliente o Username
          </CompilaCampi>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={0} sm={0} md={3}></Grid>
        <Grid item xs={12} sm={12} md={6}>
          <div class="Line-8"></div>
        </Grid>
        <Grid item xs={0} sm={0} md={3}></Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <ChoseUser>Scegli lo Username che vuoi recuperare</ChoseUser>
        </Grid>
      </Grid>
      <UserList container spacing={5}>
        <Grid item xs={0} sm={0} md={4}></Grid>

        <Grid item xs={12} sm={12} md={4}>
          <SimpleBox>
            <ListaUsers>
              <SelezioneUser value={value} onChange={handleChange}>
                {users.map((option) => (
                  <FormControlLabel 
                    value={option.id} 
                    control={<Radio />} 
                    label={<span className="notranslate">{option.code}</span>} 
                  />
                ))}
              </SelezioneUser>
            </ListaUsers>
          </SimpleBox>
        </Grid>
        <Grid item xs={0} sm={0} md={4}></Grid>
      </UserList>

      {notCode != false &&
        <Grid container>
          <Grid item xs={0} sm={0} md={4}></Grid>
          <Grid item xs={12} sm={12} md={4}>
            <SimpleBox2>
              <SendEmailButton
                disabled={loading}
                onClick={sendCodes}
              >Inviami i codici via email</SendEmailButton>
            </SimpleBox2>
            <ResponseSendCodes dangerouslySetInnerHTML={{ __html: sendCodesResponse }}>
            </ResponseSendCodes>
            <Grid item xs={0} sm={0} md={4}></Grid>
          </Grid>
        </Grid>
      }

      {notCode != true &&
        <Buttons container spacing={2}>
          <Grid item xs={0} sm={0} md={4}></Grid>
          <Grid item xs={12} sm={12} md={2}>
            <BackButton fullWidth variant="contained"
              onClick={close}
              disabled={loading}
            >
              CHIUDI
            </BackButton>
          </Grid>
          <Grid item xs={12} sm={12} md={2}>
            <UpButton fullWidth variant="contained"
              onClick={getSetEmail}
              disabled={loading}
            >
              PROSEGUI
            </UpButton>
          </Grid>
        </Buttons>
      }
    </Container>
  );
}

export default SelectUserName;